// extracted by mini-css-extract-plugin
export default {"image":"nlzAZejx","link":"aew52ebl","mobile":"mobile","icon":"_EM0rwDY","social":"W0hvqD8s","time":"EtqWZUZs","rubric":"FjvurPg_","button":"B5lGSgYp"};